import { createRoutes } from '@/routing';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

export default defineNuxtPlugin({
	name: 'router-setup',
	dependsOn: ['core-env'],
	parallel: false,
	setup() {
		const context = useNuxtApp();
		const languageStore = useLanguageStore(context.$pinia);
		const routingStore = useRoutingStore(context.$pinia);

		const s = getHrTime();
		const routes = createRoutes(languageStore.webLocale, routingStore.activeDomain);
		recordSsrPhase(context, 'routes-create', s);

		routes.forEach(route => context.$router.addRoute(route));
		// Keep routing store in sync with the actual router lifecycle.
		// `afterEach` runs once navigation is confirmed, avoiding UI flashes where the header
		// reflects the target route while the old page is still on screen.
		context.$router.afterEach(to => {
			void routingStore.setActiveRoute(to);
		});

		// Initial sync (covers first render / hydration where `afterEach` may not have run yet).
		void routingStore.setActiveRoute(context.$router.currentRoute.value);
	},
});
